import { createHbmlHeadersNodeComponents } from "./common/createHbmlHeadersNodeComponents";

export const HbmlHeaders1Node = createHbmlHeadersNodeComponents(1);
